import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";

export const addWhatsAppAccount = async (token, agentId, accountData) => {
  try {
    const response = await apiFetch(`${backUrl}/whatsapp-accounts/${agentId}/accounts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(accountData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding WhatsApp account:", error);
    throw error;
  }
};

export const getWhatsAppAccounts = async (token, agentId) => {
  try {
    const response = await apiFetch(`${backUrl}/whatsapp-accounts/${agentId}/accounts`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching WhatsApp accounts:", error);
    throw error;
  }
};

export const updateWhatsAppAccount = async (token, agentId, accountId, updateData) => {
  try {
    const response = await apiFetch(`${backUrl}/whatsapp-accounts/${agentId}/accounts/${accountId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating WhatsApp account:", error);
    throw error;
  }
};

export const removeWhatsAppAccount = async (token, agentId, accountId) => {
  try {
    const response = await apiFetch(`${backUrl}/whatsapp-accounts/${agentId}/accounts/${accountId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error removing WhatsApp account:", error);
    throw error;
  }
};

export const testWhatsAppConnection = async (token, agentId, accountId) => {
  try {
    const response = await apiFetch(`${backUrl}/whatsapp-accounts/${agentId}/accounts/${accountId}/test`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error testing WhatsApp connection:", error);
    throw error;
  }
};

export const registerWebhook = async (token, agentId, accountId) => {
  try {
    const response = await apiFetch(`${backUrl}/whatsapp-accounts/${agentId}/accounts/${accountId}/register-webhook`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error registering webhook:", error);
    throw error;
  }
};

